import { atom } from "recoil";

const quizLoading = atom({
  key: 'quiz-loading',
  default: false,
});

const quizCurrentPage = atom({
  key: 'quiz-current-page',
  default: 1,
});

const quizSearch = atom({
  key: 'quiz-search',
  default: '',
});

const quizData = atom({
  key: 'quiz-data',
  default: {},
});

const quizInput = atom({
  key: 'quiz-input',
  default: {
    question: '',
    answers: [],
  }
});

const quizDetail = atom({
  key: 'quiz-detail',
  default: {},
});

const quizMessage = atom({
  key: 'quiz-message',
  default: {} // {success: bool, text: string}
});

const quizDeleted = atom({
  key: 'quiz-delete',
  default: false,
});

export {
  quizLoading,
  quizCurrentPage,
  quizSearch,
  quizData,
  quizInput,
  quizMessage,
  quizDeleted,
  quizDetail,
}